
import React from 'react';
import { siteConfig } from '../config/site';
import { MapPin, Clock, Zap } from 'lucide-react';
import { useLanguage } from '../App';

const Locations: React.FC = () => {
  const { t, openBooking } = useLanguage();
  return (
    <section id="coverage" className="py-20 px-6 bg-black relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_20%_50%,_rgba(205,127,50,0.1)_0%,_transparent_50%)]"></div>
        <div className="absolute bottom-0 right-0 w-full h-full bg-[radial-gradient(circle_at_80%_50%,_rgba(205,127,50,0.1)_0%,_transparent_50%)]"></div>
      </div>

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center mb-12 reveal reveal-up active">
          <h3 className="text-accent font-bold tracking-[0.3em] uppercase text-[10px] mb-3">{t.availability}</h3>
          <h2 className="text-4xl sm:text-6xl font-serif font-bold mb-6 uppercase tracking-tighter">{t.southFlorida}</h2>
          <div className="w-24 h-0.5 bg-accent mx-auto mb-8"></div>
          
          <div className="max-w-xl mx-auto space-y-6">
            <p className="text-xl sm:text-2xl font-serif italic text-white/70 leading-snug">
              "{t.locationsQuote}"
            </p>
            
            <div className="flex flex-wrap justify-center gap-6 text-white/30 uppercase font-black tracking-[0.2em] text-[9px]">
              <div className="flex items-center gap-2">
                <MapPin size={12} className="text-accent/50" />
                <span>Concierge</span>
              </div>
              <div className="flex items-center gap-2">
                <Zap size={12} className="text-accent/50" />
                <span>{t.southFlorida}</span>
              </div>
              <div className="flex items-center gap-2">
                <Clock size={12} className="text-accent/50" />
                <span>{siteConfig.hours.weekdays}</span>
              </div>
            </div>

            <div className="pt-8 flex flex-col sm:flex-row gap-4 justify-center items-center">
              <button 
                onClick={openBooking}
                className="w-full sm:w-auto px-10 py-5 bg-accent text-black font-black uppercase tracking-[0.2em] text-[10px] hover:bg-white transition-all duration-500 shadow-xl"
              >
                {t.bookYourLocation}
              </button>
              <a 
                href={`tel:${siteConfig.phone}`}
                className="w-full sm:w-auto px-10 py-5 border border-white/10 text-white/50 font-black uppercase tracking-[0.2em] text-[10px] hover:border-accent hover:text-accent transition-all duration-500"
              >
                {t.inquireDirectly}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Locations;
